import React, { useState, useEffect } from 'react';
import './HeroSlider.css';

import slide1 from '../assets/slide1.png';
import slide2 from '../assets/slide2.png';
import slide3 from '../assets/slide3.png';
import slide4 from '../assets/slide2.png';

const slides = [
  {
    image: slide1,
    position: 'center center',
    lines: ['POUR IT.', 'DRESS IT.', 'SPREAD IT.'],
    buttonText: 'RECIPES',
  },
  {
    image: slide2,
    position: 'left center',
    lines: ['FROM SESAME', 'FARM TO', 'TABLE'],
    buttonText: 'OUR FAMILY',
  },
  {
    image: slide3,
    position: 'center center',
    lines: ['100% INCREDIBLE', 'SESAME', 'GOODNESS'],
    buttonText: 'SHOP NOW',
  },
  {
    image: slide2,
    position: 'right center',
    lines: ['THE POWER OF', 'SESAME FOR', 'ALL!'],
    buttonText: 'LEARN MORE',
  },
];

const HeroSlider = () => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="hero-slider">
      {/* Background Slides */}
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`slide ${index === current ? 'active' : ''}`}
          style={{
            backgroundImage: `url(${slide.image})`,
            backgroundPosition: slide.position,
          }}
        >
          {index === current && (
            <div className="slide-text" key={current}>
              <h1>
                {slide.lines.map((line, idx) => (
                  <span key={idx}>{line}</span>
                ))}
              </h1>
              <button>{slide.buttonText}</button>
            </div>
          )}
        </div>
      ))}

      {/* Multi-segment Progress Bar */}
      <div className="multi-progress-bar">
        {slides.map((_, index) => (
          <div
            key={index}
            className={`progress-segment ${index === current ? 'active-segment' : ''}`}
          >
            {index === current && (
              <div className="progress-fill" key={current}></div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default HeroSlider;
